import { render, staticRenderFns } from "./consumption_details.vue?vue&type=template&id=1efa4182&scoped=true&"
import script from "./consumption_details.vue?vue&type=script&lang=js&"
export * from "./consumption_details.vue?vue&type=script&lang=js&"
import style0 from "./consumption_details.vue?vue&type=style&index=0&id=1efa4182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efa4182",
  null
  
)

export default component.exports